import { Link } from "react-router-dom";
import DashboardLayout from "../components/DashboardLayout";

export default function FavoritesPage() {
  return (
    <DashboardLayout>
      <div className="p-5 md:p-6">
        <h1 className="text-lg md:text-xl font-bold text-gray-800 mb-6">
          我的收藏
        </h1>

        <div className="text-center py-16">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-gray-100">
            <i className="ri-heart-line text-2xl text-gray-400" />
          </div>
          <p className="text-gray-500">暂无收藏内容</p>
          <Link
            to="/"
            className="inline-flex items-center mt-4 px-5 py-2.5 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-colors text-sm"
          >
            去浏览
          </Link>
        </div>
      </div>
    </DashboardLayout>
  );
}
